import { FreeReducedMealAppIncome } from './free-reduced-meal-app-income.model';

export class FreeReducedMealAppAdultIncome extends FreeReducedMealAppIncome {
    AdultID: number;
    AdultIncomeSubTypeID: number;
    AdultIncomeTypeID: number;
}